(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vx-circuit-fx"] && !Shopify.designMode) return;
  try {
    /* VIRANIX áramkör-animáció – a „VIRANIX Akadémia – így működik” oldal fejléc-animációjának szekció-változata.
   A szekció széleiről induló pályák 45°-os törésekkel a célelem felé futnak össze, rajtuk fényimpulzusok haladnak,
   érkezéskor felvillannak. mode: hero (videó, mobilon a logó) / emblem (Akadémia-jelvény) / footer (nagy felirat) / edge */
(function(){
  if (window.vxCircuit) return;
  var mq = function(q){ return window.matchMedia ? window.matchMedia(q).matches : false; };
  var RM = mq('(prefers-reduced-motion: reduce)');
  var FINE = mq('(hover: hover) and (pointer: fine)');
  var D8 = [[1,0],[1,1],[0,1],[-1,1],[-1,0],[-1,-1],[0,-1],[1,-1]];
  var G = 24, R = Math.random;
  var all = [], raf = 0, last = 0, trims = {};

  function withLen(p){ var c = [0]; for (var i = 1; i < p.length; i++) c.push(c[i-1] + Math.hypot(p[i][0] - p[i-1][0], p[i][1] - p[i-1][1])); return { p: p, c: c, L: c[c.length - 1] }; }
  function at(t, s){
    if (s <= 0) return t.p[0]; if (s >= t.L) return t.p[t.p.length - 1];
    var i = 1; while (t.c[i] < s) i++;
    var f = (t.c[i] - t.c[i-1]) ? (s - t.c[i-1]) / (t.c[i] - t.c[i-1]) : 0;
    return [t.p[i-1][0] + (t.p[i][0] - t.p[i-1][0]) * f, t.p[i-1][1] + (t.p[i][1] - t.p[i-1][1]) * f];
  }
  // 45°-os lépésekkel a cél felé, időnként kitérve – a bemutató oldal útvonal-logikája
  function route(x, y, tx, ty, maxY){
    var p = [[x, y]];
    for (var i = 0; i < 60; i++){
      var dx = tx - x, dy = ty - y, dist = Math.hypot(dx, dy); if (dist < 14) break;
      var q = Math.round(Math.atan2(dy, dx) / (Math.PI / 4)); if (R() < .22 && dist > 120) q += R() < .5 ? 1 : -1;
      var d = D8[((q % 8) + 8) % 8], f = d[0] && d[1] ? Math.SQRT1_2 : 1, len = Math.min(dist, G * (2 + Math.floor(R() * 5)));
      x += d[0] * len * f; y += d[1] * len * f; if (maxY != null && y > maxY) y = maxY; p.push([x, y]);
    }
    return p;
  }
  function pulse(c, C, t, s){
    for (var d = 80; d > 0; d -= 4){
      if (s - d < 0 || s - d > t.L) continue;
      var a = at(t, s - d), b = at(t, Math.min(t.L, s - d + 4));
      c.strokeStyle = 'rgba(' + C.p + ',' + ((1 - d / 80) * .85).toFixed(3) + ')'; c.lineWidth = 1.8;
      c.beginPath(); c.moveTo(a[0], a[1]); c.lineTo(b[0], b[1]); c.stroke();
    }
    if (s <= t.L){
      var h = at(t, s), g = c.createRadialGradient(h[0], h[1], 0, h[0], h[1], 11);
      g.addColorStop(0, 'rgba(' + C.p + ',.95)'); g.addColorStop(1, 'rgba(' + C.p + ',0)');
      c.fillStyle = g; c.beginPath(); c.arc(h[0], h[1], 11, 0, 7); c.fill();
    }
  }
  // Logókép tényleges kontúrja (az átlátszó szegély nélkül), a kép arányában: [bal, fent, jobb, lent]
  function trim(img, done){
    var src = img.currentSrc || img.src;
    if (!src) return [0, 0, 1, 1];
    if (trims[src]) return trims[src].v;
    var o = trims[src] = { v: [0, 0, 1, 1] }, im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function(){
      try {
        var w = 240, h = Math.max(1, Math.round(w * im.naturalHeight / im.naturalWidth)), cv = document.createElement('canvas');
        cv.width = w; cv.height = h; var c = cv.getContext('2d'); c.drawImage(im, 0, 0, w, h);
        var px = c.getImageData(0, 0, w, h).data, x0 = w, y0 = h, x1 = -1, y1 = -1;
        for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) if (px[(y * w + x) * 4 + 3] > 40){ if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
        if (x1 >= 0){ o.v = [x0 / w, y0 / h, (x1 + 1) / w, (y1 + 1) / h]; done(); }
      } catch (e) {}
    };
    im.src = src;
    return o.v;
  }

  function Field(el){
    this.el = el; this.host = el.parentElement; this.cv = el.querySelector('canvas'); this.ctx = this.cv.getContext('2d');
    this.mode = el.getAttribute('data-mode') || 'edge';
    var ink = el.getAttribute('data-tone') === 'ink';
    this.C = ink ? { tr: 'rgba(0,0,0,.075)', dot: 'rgba(0,0,0,.22)', p: '0,0,0' } : { tr: 'rgba(255,255,255,.075)', dot: 'rgba(255,255,255,.22)', p: '255,255,255' };
    this.TR = []; this.PU = []; this.FL = []; this.on = false; this.ready = false;
    this.intro = RM ? 1 : 0; this.age = 0; this.hov = 0;
    var self = this, tm;
    this.rebuild = function(){ clearTimeout(tm); tm = setTimeout(function(){ self.build(); wake(); }, 180); };
    this.ro = 'ResizeObserver' in window ? new ResizeObserver(this.rebuild) : null;
    if (this.ro) this.ro.observe(this.host);
    this.build();
  }
  // Célelem: fejlécben asztalon a videó, mobilon a logó; Akadémia-blokkban a jelvény; láblécben a nagy felirat
  Field.prototype.target = function(){
    var h = this.host;
    if (this.mode === 'hero') return window.innerWidth >= 990 ? h.querySelector('.vx-hh__media') : (h.querySelector('.vx-hh__logo') || h.querySelector('.vx-hh__title'));
    if (this.mode === 'emblem') return h.querySelector('.vx-ak__emblem');
    if (this.mode === 'footer') return h.querySelector('.vx-ft__mark img');
    return null;
  };
  Field.prototype.build = function(){
    var r = this.el.getBoundingClientRect(), W = Math.round(r.width), H = Math.round(r.height);
    if (!W || !H) return;
    var d = Math.min(2, window.devicePixelRatio || 1);
    this.W = W; this.H = H; this.d = d;
    this.cv.width = W * d; this.cv.height = H * d; this.ctx.setTransform(d, 0, 0, d, 0, 0);
    var tEl = this.target(), T = null, IR = null;
    if (tEl){
      var b = tEl.getBoundingClientRect();
      if (b.width > 20 && b.height > 10){
        T = IR = { l: b.left - r.left, t: b.top - r.top, r: b.right - r.left, b: b.bottom - r.top };
        if (tEl.tagName === 'IMG'){ var f = trim(tEl, this.rebuild), iw = IR.r - IR.l, ih = IR.b - IR.t; T = { l: IR.l + f[0] * iw, t: IR.t + f[1] * ih, r: IR.l + f[2] * iw, b: IR.t + f[3] * ih }; }
      }
      if (this.ro && tEl !== this.tEl){ this.ro.observe(tEl); this.tEl = tEl; }
    }
    this.T = T; this.IR = IR;
    // Lábléc: a pályák a tartalom alatti sávban látszanak, a szöveg mögött elhalványulnak
    if (this.mode === 'footer'){
      var mk = '';
      if (T){
        var cb = 0, cs = this.host.querySelectorAll('.vx-ft__cta, .vx-ft__grid > *');
        for (var i = 0; i < cs.length; i++){ var q = cs[i].getBoundingClientRect(); if (q.height) cb = Math.max(cb, q.bottom - r.top); }
        var m0 = Math.max(0, Math.min(cb - 12, T.t - 96)), m1 = Math.max(m0 + 36, Math.min(cb + 44, T.t - 30));
        mk = 'linear-gradient(180deg,transparent ' + Math.round(m0) + 'px,#000 ' + Math.round(m1) + 'px)';
      }
      this.el.style.webkitMaskImage = this.el.style.maskImage = mk;
    }
    this.card = this.mode === 'hero' && !!T && window.innerWidth >= 990;
    this.ring = this.mode === 'emblem' && !!T;
    this.word = this.mode === 'footer' && T ? tEl : null;
    this.max = this.mode === 'hero' ? (this.card ? 18 : 9) : this.mode === 'emblem' ? 14 : this.mode === 'footer' ? 8 : 5;
    this.rate = this.mode === 'hero' || this.mode === 'emblem' ? .12 : .055;
    // Célelem nélkül nincs pálya (cél nélküli vonalak sehol); a szél-változat csak kifejezett edge módban
    this.TR = !T ? (this.mode === 'edge' ? this.toEdge() : []) : this.ring ? this.toRing(T) : this.toRect(T);
    this.PU = []; this.FL = [];
    this.stat = this.stat || document.createElement('canvas');
    this.stat.width = W * d; this.stat.height = H * d;
    var sc = this.stat.getContext('2d'); sc.setTransform(d, 0, 0, d, 0, 0); this.paint(sc, 1);
    if (this.word){ this.wc = this.wc || document.createElement('canvas'); this.wc.width = Math.ceil((IR.r - IR.l) * d); this.wc.height = Math.ceil((IR.b - IR.t) * d); }
    this.ready = true;
    this.frame(0);   // a vászon átméretezése törli a képet: azonnal újrarajzoljuk
  };
  // Pályák a célelem oldalain lévő „lábakhoz”; az utolsó szakasz merőleges az oldalra (mint egy chip lábai)
  Field.prototype.toRect = function(T){
    var W = this.W, H = this.H, out = [], used = {}, lanes;
    if (this.mode === 'footer') lanes = [['l', 't', 1], ['r', 't', 1]];
    else {
      lanes = [['l', 'l', .42]];
      if (T.t > 40) lanes.push(['t', 't', .22]);
      if (H - T.b > 40) lanes.push(['b', 'b', .22]);
      if (W - T.r > 50) lanes.push(['r', 'r', .14]);
    }
    var sum = 0; lanes.forEach(function(l){ sum += l[2]; });
    var n = this.mode === 'footer' ? Math.round(Math.min(26, Math.max(14, W / 56))) : Math.round(Math.min(42, Math.max(16, (W + H) / 44)) * (this.card ? 1 : .7));
    for (var k = 0; k < n; k++){
      var u = R() * sum, ln = lanes[0];
      for (var i = 0; i < lanes.length; i++){ u -= lanes[i][2]; if (u <= 0){ ln = lanes[i]; break; } }
      var pin = this.pin(ln[1], T, used); if (!pin) continue;
      var sx, sy;
      if (ln[0] === 'l' || ln[0] === 'r'){
        sx = ln[0] === 'l' ? -12 : W + 12;
        sy = this.mode === 'footer' ? T.t - 26 - R() * Math.min(150, Math.max(40, T.t - 26)) : R() * H;
      } else { sx = R() * Math.max(40, T.r - 40); sy = ln[0] === 't' ? -12 : H + 12; }
      var m = G * (1 + Math.floor(R() * 3)), A = [pin[0] + pin[2] * m, pin[1] + pin[3] * m];
      var p = route(sx, sy, A[0], A[1], this.mode === 'footer' ? T.t - 14 : null); p.push(A, [pin[0], pin[1]]);
      out.push(withLen(p));
    }
    return out;
  };
  // Szabad láb a célelem adott oldalán (12 px-es osztás), a kifelé mutató iránnyal
  Field.prototype.pin = function(side, T, used){
    var hz = side === 't' || side === 'b', a = hz ? T.l : T.t, b = hz ? T.r : T.b, m = Math.min(30, (b - a) * .2), gap = 8, slots = Math.floor((b - a - 2 * m) / 12);
    if (slots < 1) return null;
    for (var k = 0; k < 10; k++){
      var i = Math.floor(R() * slots); if (used[side + i]) continue; used[side + i] = 1;
      var v = a + m + i * 12;
      return side === 'l' ? [T.l - gap, v, -1, 0] : side === 'r' ? [T.r + gap, v, 1, 0] : side === 't' ? [v, T.t - gap, 0, -1] : [v, T.b + gap, 0, 1];
    }
    return null;
  };
  // Akadémia-jelvény: a pályák a jelvény körüli kör pontjaiba futnak – pontosan, mint a bemutató oldalon
  Field.prototype.toRing = function(T){
    var W = this.W, H = this.H, cx = (T.l + T.r) / 2, cy = T.t + (T.b - T.t) * .55, rad = (T.r - T.l) * .56, out = [];
    var n = Math.round(Math.min(34, Math.max(16, (W + H) / 52))), wts = [.3, .3, .3, .1];   // fent, jobbra, lent, balra (a szöveg felől kevesebb)
    for (var k = 0; k < n; k++){
      var u = R(), e = 0; while (e < 3 && (u -= wts[e]) > 0) e++;
      var x = e === 1 ? W + 12 : e === 3 ? -12 : R() * W, y = e === 0 ? -12 : e === 2 ? H + 12 : R() * H, a = R() * 6.283;
      out.push(withLen(route(x, y, cx + Math.cos(a) * rad, cy + Math.sin(a) * rad * .95)));
    }
    return out;
  };
  // Csendes változat: a jobb szélről befutó pályák, a végükön csatlakozóponttal
  Field.prototype.toEdge = function(){
    var W = this.W, H = this.H, band = Math.max(140, Math.min(340, W * .24)), n = Math.round(Math.min(16, Math.max(8, H / 70))), out = [];
    for (var k = 0; k < n; k++){
      var tx = W - 30 - R() * (band - 30), ty = 24 + R() * Math.max(10, H - 48);
      var sy = Math.max(-12, Math.min(H + 12, ty + (R() - .5) * 240));
      var p = route(W + 12, sy, tx, ty); p.push([tx, ty]);
      var t = withLen(p); t.pad = true; out.push(t);
    }
    return out;
  };
  // Álló réteg: fénykör a célelem mögött, halvány pályák, végpontok. prog < 1: a pályák kirajzolódása
  Field.prototype.paint = function(c, prog){
    var C = this.C, T = this.T, n = this.TR.length;
    c.lineCap = 'round'; c.lineJoin = 'round';
    if (T && !this.ring){
      var cx = (T.l + T.r) / 2, cy = (T.t + T.b) / 2, w = T.r - T.l, h = T.b - T.t, rx = this.word ? w * .6 : Math.max(w, h) * .75, ry = this.word ? h * 1.6 : rx;
      c.save(); c.translate(cx, cy); c.scale(1, ry / rx);
      var g = c.createRadialGradient(0, 0, 0, 0, 0, rx);
      g.addColorStop(0, 'rgba(' + C.p + ',' + (.1 * Math.min(1, prog * 1.5)).toFixed(3) + ')'); g.addColorStop(.62, 'rgba(' + C.p + ',0)');
      c.fillStyle = g; c.beginPath(); c.arc(0, 0, rx, 0, 7); c.fill(); c.restore();
    }
    for (var i = 0; i < n; i++){
      var t = this.TR[i], lp = prog >= 1 ? 1 : Math.max(0, Math.min(1, (prog * 1.6 - i / n * .9) / .6));
      if (lp <= 0) continue;
      var s = lp * t.L, j;
      c.strokeStyle = C.tr; c.lineWidth = 1.2; c.beginPath(); c.moveTo(t.p[0][0], t.p[0][1]);
      for (j = 1; j < t.p.length && t.c[j] <= s; j++) c.lineTo(t.p[j][0], t.p[j][1]);
      var e = lp < 1 ? at(t, s) : t.p[t.p.length - 1];
      if (lp < 1) c.lineTo(e[0], e[1]);
      c.stroke();
      if (lp < 1){ c.fillStyle = 'rgba(' + C.p + ',.7)'; c.beginPath(); c.arc(e[0], e[1], 1.6, 0, 7); c.fill(); }
      else if (t.pad){ c.strokeStyle = C.dot; c.lineWidth = 1.3; c.beginPath(); c.arc(e[0], e[1], 3.6, 0, 7); c.stroke(); }
      else { c.fillStyle = C.dot; c.beginPath(); c.arc(e[0], e[1], 2.2, 0, 7); c.fill(); }
    }
  };
  // Kártya körüli tágulás (a bemutató oldal jelvény-pulzálásának megfelelője)
  Field.prototype.pings = function(c){
    var T = this.T, cx = (T.l + T.r) / 2, cy = (T.t + T.b) / 2, w = T.r - T.l, h = T.b - T.t;
    for (var j = 0; j < 2; j++){
      var tt = this.age - .6 - j * 1.8; if (tt < 0) continue;
      var ph = (tt % 3.6) / 3.6, e = 1 - Math.pow(1 - ph, 3), grow = w * .07 * e, a = .35 * (1 - ph);
      var hw = w / 2 + grow, hh = h / 2 + grow, k = 26;
      c.strokeStyle = 'rgba(' + this.C.p + ',' + a.toFixed(3) + ')'; c.lineWidth = 1.2; c.beginPath();
      c.moveTo(cx - hw + k, cy - hh); c.lineTo(cx + hw, cy - hh); c.lineTo(cx + hw, cy + hh - k); c.lineTo(cx + hw - k, cy + hh); c.lineTo(cx - hw, cy + hh); c.lineTo(cx - hw, cy - hh + k); c.closePath(); c.stroke();
    }
  };
  // Lábléc: ahol egy impulzus beérkezik, ott a nagy felirat betűi felizzanak
  Field.prototype.lightWord = function(c){
    var img = this.word, I = this.IR, w = I.r - I.l, h = I.b - I.t, d = this.d, gh = this.T.b - this.T.t;
    if (!img.complete || !img.naturalWidth) return;
    var wc = this.wc.getContext('2d'); wc.setTransform(d, 0, 0, d, 0, 0);
    wc.globalCompositeOperation = 'source-over'; wc.clearRect(0, 0, w, h);
    for (var i = 0; i < this.FL.length; i++){
      var f = this.FL[i]; if (!f.w) continue;
      var x = f.p[0] - I.l, y = f.p[1] - I.t + gh * .35, g = wc.createRadialGradient(x, y, 0, x, y, 170);
      g.addColorStop(0, 'rgba(255,255,255,' + (.85 * f.a).toFixed(3) + ')'); g.addColorStop(1, 'rgba(255,255,255,0)');
      wc.fillStyle = g; wc.fillRect(x - 170, y - 170, 340, 340);
    }
    wc.globalCompositeOperation = 'destination-in'; wc.drawImage(img, 0, 0, w, h);
    c.drawImage(this.wc, I.l, I.t, w, h);
  };
  Field.prototype.spawn = function(t, s){ t = t || this.TR[Math.floor(R() * this.TR.length)]; if (t) this.PU.push({ t: t, s: s || 0, v: (2.4 + R() * 3.2) * 60 }); };
  // A pozícióhoz legközelebbi pálya-töréspontok (egérrel/érintéssel indított impulzushoz)
  Field.prototype.near = function(x, y, lim){
    var best = [], i, j;
    for (i = 0; i < this.TR.length; i++){ var t = this.TR[i]; for (j = 0; j < t.p.length - 1; j++){ var dd = Math.hypot(t.p[j][0] - x, t.p[j][1] - y); if (dd < lim) best.push([dd, t, t.c[j]]); } }
    return best.sort(function(a, b){ return a[0] - b[0]; });
  };
  Field.prototype.frame = function(dt){
    var c = this.ctx, C = this.C, self = this, k = dt * 60;
    c.clearRect(0, 0, this.W, this.H);
    if (this.intro < 1){ this.intro = Math.min(1, this.intro + dt / 2.2); this.paint(c, this.intro); }
    else c.drawImage(this.stat, 0, 0, this.W, this.H);
    if (RM || this.intro < 1) return;
    this.age += dt;
    if (this.PU.length < this.max && R() < 1 - Math.pow(1 - this.rate, k)) this.spawn();
    if (this.card) this.pings(c);
    this.PU = this.PU.filter(function(q){
      q.s += q.v * dt; pulse(c, C, q.t, q.s);
      if (q.s > q.t.L && !q.f){ q.f = 1; self.FL.push({ p: q.t.p[q.t.p.length - 1], a: 1, w: !!self.word }); }
      return q.s - 80 < q.t.L;
    });
    this.FL = this.FL.filter(function(f){
      f.a -= .035 * k; if (f.a <= 0) return false;
      var g = c.createRadialGradient(f.p[0], f.p[1], 0, f.p[0], f.p[1], 26);
      g.addColorStop(0, 'rgba(' + C.p + ',' + (.55 * f.a).toFixed(3) + ')'); g.addColorStop(1, 'rgba(' + C.p + ',0)');
      c.fillStyle = g; c.beginPath(); c.arc(f.p[0], f.p[1], 26, 0, 7); c.fill();
      return true;
    });
    if (this.word && this.FL.length) this.lightWord(c);
  };

  function loop(ts){
    raf = 0;
    var dt = last ? Math.min(.05, (ts - last) / 1000) : .016; last = ts;
    all = all.filter(function(f){ return f.el.isConnected; });
    var act = false;
    for (var i = 0; i < all.length; i++){ var f = all[i]; if (f.on && f.ready){ f.frame(dt); act = true; } }
    if (act && !document.hidden) raf = requestAnimationFrame(loop); else last = 0;
  }
  function wake(){ if (!raf && !RM) raf = requestAnimationFrame(loop); }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function(es){
    es.forEach(function(e){ var f = e.target._vxc; if (f){ f.on = e.isIntersecting; if (f.on) wake(); } });
  }, { rootMargin: '60px' }) : null;
  function hit(x, y){
    for (var i = 0; i < all.length; i++){ var f = all[i]; if (!f.on || !f.ready || f.intro < 1) continue; var b = f.el.getBoundingClientRect(); if (x >= b.left && x <= b.right && y >= b.top && y <= b.bottom) return [f, x - b.left, y - b.top]; }
    return null;
  }
  if (!RM){
    // Egér: a közeli pályán impulzus indul a célelem felé
    if (FINE) window.addEventListener('pointermove', function(e){
      var h = hit(e.clientX, e.clientY), now = performance.now(); if (!h || now - h[0].hov < 160 || h[0].PU.length > h[0].max + 4) return;
      var n = h[0].near(h[1], h[2], 90); if (n.length){ h[0].hov = now; h[0].spawn(n[0][1], n[0][2]); wake(); }
    }, { passive: true });
    // Kattintás/érintés a háttéren: több impulzus a legközelebbi pályákon, felvillanás a ponton
    document.addEventListener('pointerdown', function(e){
      if (e.target.closest && e.target.closest('a,button,input,select,textarea,label,summary,video,[role="button"]')) return;
      var h = hit(e.clientX, e.clientY); if (!h) return;
      h[0].near(h[1], h[2], 160).slice(0, 5).forEach(function(n){ h[0].spawn(n[1], n[2]); });
      h[0].FL.push({ p: [h[1], h[2]], a: 1 }); wake();
    }, { passive: true });
  }
  function scan(){
    var els = document.querySelectorAll('.vx-cfx:not([data-vxc])');
    for (var i = 0; i < els.length; i++){
      var el = els[i]; el.setAttribute('data-vxc', '1');
      if (!el.offsetWidth || !el.querySelector('canvas')) continue;   // rejtett (ismételt render)
      var f = new Field(el); el._vxc = f; all.push(f);
      if (io) io.observe(el); else { f.on = true; wake(); }
    }
  }
  document.addEventListener('visibilitychange', function(){ if (!document.hidden) wake(); });
  document.addEventListener('shopify:section:load', scan);
  if (document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', scan);
  // Tesztelési segédlet: step(ms) – képkockák léptetése kézzel
  window.vxCircuit = { scan: scan, get all(){ return all; }, step: function(ms){ for (var t = 0; t < ms; t += 16) all.forEach(function(f){ if (f.ready) f.frame(.016); }); } };
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vx-teknos"] && !Shopify.designMode) return;
  try {
    /* Akadémia-jelvény: akkor áll össze, amikor görgetéssel a képernyőre ér (egyszer) */
(function(){
  if (window.vxTeknos) return; window.vxTeknos = 1;
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function(es){
    es.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('go'); io.unobserve(e.target); } });
  }, { threshold: .35 }) : null;
  function scan(){
    [].forEach.call(document.querySelectorAll('.vx-tt:not([data-vxt])'), function(s){ s.setAttribute('data-vxt', '1'); if (io) io.observe(s); else s.classList.add('go'); });
  }
  if (document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
})();
  } catch(e) { console.error(e); }
})();

})();
